import { useState, type KeyboardEvent } from 'react';
import { TextField } from '../primitives/TextField';
import type { CellValue, Column } from '../Table';

export interface TableCellEditorProps {
  column: Column;
  value: CellValue;
  rowId: string;
  dataTestId: string;
  onCommit: (newValue: CellValue) => void;
  onCancel: () => void;
}

/** Click-to-edit text cell editor (future custom properties). */
export function TableCellEditor({
  column,
  value,
  rowId,
  dataTestId,
  onCommit,
  onCancel
}: TableCellEditorProps) {
  const initial = value == null ? '' : String(value);
  const [draft, setDraft] = useState(initial);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      onCommit(draft);
    }
  };

  return (
    <TextField
      id={`${rowId}-${column.key}-edit`}
      label={column.label}
      hideLabel
      table
      autoFocus
      data-testid={dataTestId}
      value={draft}
      onKeyDown={onKeyDown}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        if (column.commitOn === 'enter') onCancel();
        else onCommit(draft);
      }}
    />
  );
}
